import { render, staticRenderFns } from "./UserAccountSecurity.vue?vue&type=template&id=3c3be8c4&"
import script from "./UserAccountSecurity.vue?vue&type=script&lang=js&"
export * from "./UserAccountSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports